import { render, staticRenderFns } from "./platformTable.vue?vue&type=template&id=b717a022&scoped=true"
import script from "./platformTable.vue?vue&type=script&lang=ts"
export * from "./platformTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b717a022",
  null
  
)

export default component.exports